import { Typography } from "@chr/eds-react";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { Grid } from "@mui/material";
import { Stack } from "@mui/system";
import './ReferenceNumbers.scss';
import { ReferenceNumber } from "@/common/apis/dtos";
import { formatReferenceValues } from "@/common/utilities/referenceNumberUtils";

interface ReferenceNumbersProps {
    bolNumbers?: ReferenceNumber[];
    poNumbers?:ReferenceNumber[];
    orderNumbers?: ReferenceNumber[];
    isMobileScreen: boolean;
}

export const ReferenceNumbers = ({ bolNumbers, poNumbers, orderNumbers, isMobileScreen }: ReferenceNumbersProps) => {
    const translate = useTranslation();

    return (
    <Stack data-testId='referenceNumbers-container' spacing={3} padding={1}>
        <Typography variant="h2">{translate('Reference Numbers')}</Typography>
        <div className="ref-numbers-container">
            <Grid item xs={isMobileScreen ? 12 : 4}>
                <Typography variant="body1">{translate('BOL Number')}</Typography>
                <Typography variant="subtitle2">
                    {formatReferenceValues(bolNumbers ?? [])}
                </Typography>
            </Grid>
            <Grid item xs={isMobileScreen ? 12 : 4}>
                <Typography variant="body1">{translate('PO Number')}</Typography>
                <Typography variant="subtitle2">
                    {formatReferenceValues(poNumbers ?? [])}
                </Typography>
            </Grid>
            <Grid item xs={isMobileScreen ? 12 : 4}>
                <Typography variant="body1">{translate('Order Number')}</Typography>
                <Typography variant="subtitle2">                    
                    {formatReferenceValues(orderNumbers ?? [])}                    
                </Typography>
            </Grid>
        </div>
    </Stack>
    );
};